import React, { useEffect, useState } from "react";
import Breadcrumbs from '../../components/Common/Breadcrumb';
import { Label,Input,Modal,ModalHeader,Button } from "reactstrap";
import Table from 'react-bootstrap/Table';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import Form from 'react-bootstrap/Form';
import 'bootstrap/dist/css/bootstrap.min.css';
import {ToastContainer,toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import FloatingLabel from 'react-bootstrap/FloatingLabel';

export default function Rates() {
    const[email,setEmail] = useState('');
    const[company,setCompany]=useState('');
    const[rates, setRates] = useState([]);
    const[selectedRate, setSelectedrate] = useState('');
    const[sDate, setSdate] = useState('');
    const[eDate, setEdate] = useState('');
    const[modal, setModal] = useState(false);
    const[modal2, setModal2] = useState(false)
    const[title,setTitle] = useState("");
    const[rateType, setRatetype] = useState('')
    const[amount, setAmount] = useState("")
    const[updateText, setUpdatetext] = useState('Save changes');
    const[submitText, setSubmittext] = useState('Submit')

    const handleDateChange = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setEdate(millisecondsSinceEpoch);
    
    };
    const handleDateChange2 = (e) => {
        const dateTime = e.target.value;
        const millisecondsSinceEpoch = new Date(dateTime).getTime();
        setSdate(millisecondsSinceEpoch);
    
    };

    const toggle2=()=>{
        setModal2(!modal2)
    }

    

    const toggle =async(e)=>{
        const id = e.target.value;
        setSelectedrate(id)
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getThisrate?id=${id}`);
        const data = await res.json();
        setSdate(new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(data.startDate));
        setTitle(data.title)
        setModal(!modal)
    }



    useEffect(() => {
    const fetchProfile = async () => {
        try {
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/profile', {
            credentials: 'include', // to send cookies
        });
        const data = await res.json();

        if (data.valid) {
            setEmail(data.email)
        } else {}
        } catch (error) {} 
    };

    fetchProfile();
    }, []);

    //get store id
    useEffect(()=>{
    const fetchData = async()=>{
        try{
        const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/getUserdetails?email=${email}`);
        const data = await res.json();
        setCompany(data.company)
        }
        catch(err){}
    }

    if(email){
    fetchData();
    }

    },[email]);


    useEffect(()=>{

        const fetchRates = async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/fetchCompanyrates?company=${company}`);
            const data = await res.json();
            setRates(data)
        }

        if(company){
            fetchRates();
        }

    },[company])

    const fetchRates = async()=>{
            const res = await fetch(`https://easyboxadminapi.uuidesign.xyz/api/fetchCompanyrates?company=${company}`);
            const data = await res.json();
            setRates(data)
        }

    const updateRate =async()=>{
        if(eDate !== ''){
            setUpdatetext('Please wait...')
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/updateRate',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({selectedRate,eDate}),
            credentials:"include"
        })

        const data = await res.json();
        const {success} = data;
        if(success == true){
            toast.success('Changes have been saved');
            setUpdatetext('Save changes')
            fetchRates();
            setEdate('')
            setModal(false)

        }
        else{
            toast.error('Something went wrong!')
            setUpdatetext('Save changes')
        }
        }
        else{
            toast.error('Please enter an end date!')
        }
    }

    const submitRate =async()=>{
        if(eDate !== ''){
            setSubmittext('Please wait...')
        const res = await fetch('https://easyboxadminapi.uuidesign.xyz/api/submitRate',{
            method:"POST",
            headers:{
                "Content-Type":"application/json"
            },
            body:JSON.stringify({sDate,eDate,company,title,rateType,amount}),
            credentials:"include"
        })

        const data = await res.json();
        const {success} = data;
        if(success == true){
            toast.success('Rate has been saved');
            setSubmittext('Submit')
            fetchRates();
            setSdate('')
            setTitle('')
            setRatetype('')
            setAmount('')
            setEdate('')
            setModal2(false)

        }
        else{
            toast.error('Something went wrong!')
            setSubmittext('Save changes')
        }
        }
        else{
            toast.error('Please enter an end date!')
        }
    }
  return (
    <div className="pagesContainer">
    <ToastContainer />
        <Breadcrumbs title="Easybox" breadcrumbItem="Rates" />
        <div className="card" style={{padding:'10px'}}>
        <div className="">
                <Button color='info' onClick={toggle2}  >+ New rate</Button>
        </div> 
        <hr />
        <div className="table-responsive">
        <Table striped bordered hover id="dataTable">

            <thead>
                <tr>
                    
                    <th scope="col">#</th>
                    <th scope="col">Title</th>
                    <th scope="col">Rate type</th>
                    <th scope="col">Amount</th>
                    <th scope="col">Start date</th> 
                    <th scope="col">End date</th>  
                </tr>
            </thead>
            <tbody>
            {rates.map((val,index)=>{
                var end;
                if(val.endDate !== null){
                    end = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.endDate)
                }
                const start = new Intl.DateTimeFormat('en-US',{month:'2-digit',day:'2-digit', year:'numeric'}).format(val.startDate);
                
                return(
                    <tr>
                        <td>{index+1}</td>
                        <td><button className="tableButton" value={val.id} onClick={toggle} >{val.title}</button></td>
                        <td>{val.rateType}</td>
                        <td>{val.amount}</td>
                        <td>{start}</td>
                        <td>{end}</td>
                      
                    </tr>
                )
            })}
            </tbody>
            </Table>
        </div>
    </div>

    <Modal isOpen={modal} toggle={toggle}>
        <ModalHeader>Edit {title}</ModalHeader>
        <div className="modalContainer">
            <p>Start date: {sDate}</p>
             <div className="mb-4" id='mb4'>
                <Label className="form-label">End date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange}
                    // value={email}

                />
                
            </div>

            <div className="modalButtons">
                <Button color='success' onClick={updateRate}>{updateText}</Button>
                <Button color='danger' style={{marginLeft:'2%'}} onClick={()=>{setModal(false)}}>Close</Button>
            </div>
        </div>

    </Modal>

    <Modal isOpen={modal2} toggle={toggle2}>
        <ModalHeader>New rate</ModalHeader>
        <div className="modalContainer">
            
        <div className="mb-4" id='mb4'>
            <Label className="form-label">Description</Label>
            <Input
                name="text"
                className="form-control"
                placeholder="Description"
                type="text"
                onChange={(e)=>{setTitle(e.target.value)}}
                value={title}

            />
                
        </div>
        <div className="mb-4" id='mb4'>
            <Label className="form-label">Rate type</Label>
            <select name="" id="" className="form-control" onChange={(e)=>{setRatetype(e.target.value)}}>
                <option selected disabled>- Rate type - </option>
                <option value='Default'>Default</option>
                <option value='Additional'>Additional</option>
            </select>
                
        </div>

        <div className="mb-4" id='mb4'>
            <Label className="form-label">Amount</Label>
            <Input
                name="text"
                className="form-control"
                placeholder="Amount"
                type="text"
                onChange={(e)=>{setAmount(e.target.value)}}
                value={amount}

            />
                
        </div>

        <div className="mb-4" id='mb4'>
                <Label className="form-label">Start date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange2}
                    // value={email}

                />
                
            </div>
             <div className="mb-4" id='mb4'>
                <Label className="form-label">End date</Label>
                <Input
                    name="text"
                    className="form-control"
                    placeholder="Search order"
                    type="datetime-local"
                    onChange={handleDateChange}
                    // value={email}

                />
                
            </div>

            <div className="modalButtons">
                <Button color='success' onClick={submitRate}>{submitText}</Button>
                <Button color='danger' style={{marginLeft:'2%'}} onClick={()=>{setModal2(false)}}>Close</Button>
            </div>
        </div>

    </Modal>
    </div>
  )
}
